<template>
  <div>
    <page-header :title="$t('scope.text_286')" />
    <page-body>
      <tenant-list :id="listId" :getParams="getParams" />
    </page-body>
  </div>
</template>

<script>
import TenantList from './components/List'

export default {
  name: 'tenantManagerIndex',
  components: {
    TenantList,
  },
  data () {
    return {
      listId: 'tenantList',
      getParams: {
        details: true,
      },
    }
  },
}
</script>
